<template>
  <v-app>
    <v-app-bar
      style="background-color: #32Cd32"
      :height="isLoggedIn && comp_ShowNavigation ? '90px' : '70px'"
      app
    >
      <v-progress-linear
        v-if="comp_isLoading && (isLoggedIn || isClubLoggedIn)"
        indeterminate
        color="blue"
        absolute
        bottom
        height="5"
      ></v-progress-linear>
      <v-container fluid class="pa-0">
        <v-row no-gutters align="center">
          <!-- Erste Zeile: Navigation, Logo, Titel, Buttons -->
          <v-col cols="12">
            <div class="d-flex align-center" style="height: 60px;">
              <div class="d-flex align-center">
                <v-app-bar-nav-icon
                  v-show="comp_ShowNavigation"
                  v-if="isLoggedIn || isClubLoggedIn"
                  @click.stop="comp_NavigationDrawer = !comp_NavigationDrawer"
                >
                </v-app-bar-nav-icon>

                <router-link to="/" class="d-flex align-center">
                  <img
                    src="/Bilder/book.png"
                    alt="schuetzenbuch.de"
                    width="50"
                    height="50"
                    class="rounded-circle mr-3"
                  />
                </router-link>

                <v-toolbar-title
                  class="text-lowercase white--text d-none d-sm-flex"
                  style="line-height: 1;"
                >
                  schuetzenbuch.de
                </v-toolbar-title>

                <v-icon
                  v-show="comp_websocket_state"
                  id="icon_websocket_online"
                >
                  mdi mdi-access-point-check
                </v-icon>
              </div>

              <v-spacer></v-spacer>

              <div class="d-flex align-center">
                <v-btn
                  v-if="isLoggedIn || isClubLoggedIn"
                  @click="logout()"
                  class="ma-2 btn_logout"
                  color="success"
                >
                  <v-icon>mdi-export</v-icon>
                  <span class="d-none d-sm-inline ml-2">Logout</span>
                </v-btn>

                <v-btn
                  v-if="!isLoggedIn && !isClubLoggedIn"
                  to="/login"
                  class="ma-2"
                  color="success"
                >
                  <v-icon>mdi-login</v-icon>
                  <span class="d-none d-sm-inline ml-2">Anmelden</span>
                </v-btn>

                <v-btn
                  v-show="comp_ShowNavigation"
                  v-if="!isLoggedIn && !isClubLoggedIn"
                  to="/register"
                  class="ma-2"
                  color="white success--text"
                >
                  <v-icon>mdi-account-plus</v-icon>
                  <span class="d-none d-sm-inline ml-2">Registrieren</span>
                </v-btn>
              </div>
            </div>
          </v-col>

          <!-- Zweite Zeile: Vereinsname -->
          <v-col
            v-if="isLoggedIn && comp_ShowNavigation"
            cols="12"
            class="pb-2"
          >
            <div class="d-flex align-center justify-end white--text px-2">
              <img
                src="/Bilder/home.png"
                class="mr-2 rounded-circle"
                width="20"
                height="20"
              />
              <span class="text-truncate" style="font-size: 0.875rem;">
                {{ this.$store.state.UserAuth.defClub }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <sidebar v-show="comp_ShowNavigation" v-if="isLoggedIn"></sidebar>
    <clubsidebar
      v-show="comp_ShowNavigation"
      v-if="isClubLoggedIn"
    ></clubsidebar>

    <bottom-nav
      v-if="comp_ShowNavigation && (isLoggedIn || isClubLoggedIn)"
    ></bottom-nav>

    <v-main>
      <v-alert
        v-if="!comp_backendReachable"
        type="error"
        prominent
        tile
        icon="mdi-wifi-off"
        class="mb-0"
      >
        <strong>Server nicht erreichbar</strong> – Die Verbindung zum Backend
        ist unterbrochen. Es wird automatisch erneut versucht…
      </v-alert>

      <!-- Hinweis auf die App für den Home-Bildschirm (src/plugins/pwa.js) -->
      <v-alert
        v-if="showInstallHint && (isLoggedIn || isClubLoggedIn)"
        type="info"
        color="#32cd32"
        icon="mdi-cellphone-arrow-down"
        tile
        dismissible
        class="mb-0"
        @input="closeInstallHint"
      >
        <strong>schuetzenbuch.de als App nutzen</strong><br />
        <template v-if="comp_installPrompt">
          Du kannst schuetzenbuch.de direkt auf deinem Handy installieren und
          dann wie eine App vom Startbildschirm öffnen.
          <div class="mt-2">
            <v-btn small color="white" class="success--text" @click="installApp()">
              Installieren
            </v-btn>
          </div>
        </template>
        <template v-else-if="isIOS">
          Tippe unten im Browser auf das Teilen-Symbol
          <v-icon small dark>mdi-export-variant</v-icon> und dann auf
          „Zum Home-Bildschirm“. Danach öffnest du schuetzenbuch.de wie eine
          App, im Vollbild und immer aktuell.
        </template>
        <template v-else>
          Öffne das Browser-Menü <v-icon small dark>mdi-dots-vertical</v-icon>
          und wähle „App installieren“ bzw. „Zum Startbildschirm hinzufügen“.
          Danach öffnest du schuetzenbuch.de wie eine App, im Vollbild und
          immer aktuell.
        </template>
      </v-alert>

      <router-view></router-view>
    </v-main>

    <!-- Neue Fassung der App wartet (Service Worker, src/plugins/pwa.js).
         z-index über dem Cookie-Hinweis (vue-cookie-law: 9999); solange der
         unten offen ist, steht die Leiste oben, damit „Verstanden“ frei bleibt -->
    <v-snackbar
      :value="comp_updateReady"
      :top="comp_cookieHintVisible"
      timeout="-1"
      app
      color="grey darken-3"
      style="z-index: 10000"
    >
      Eine neue Version von schuetzenbuch.de ist da.
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" color="#32cd32" text @click="applyUpdate()">
          Neu laden
        </v-btn>
      </template>
    </v-snackbar>

    <v-footer v-show="comp_ShowNavigation" color="#32Cd32" padless>
      <cookie-law
        ref="cookieLaw"
        theme="dark-lime"
        button-text="Verstanden"
        @accept="cookieHintOpen = false"
        @decline="cookieHintOpen = false"
        @close="cookieHintOpen = false"
      >
        <div slot="message">
          Wir setzen keine Tracking-Cookies. Für die Anmeldung speichern wir
          nur technisch notwendige Daten in deinem Browser. Mehr dazu unter
          <router-link to="/datenschutz">Datenschutz</router-link>
        </div>
      </cookie-law>
      <v-row justify="center" no-gutters>
        <v-btn
          v-for="link in links"
          :key="link.name"
          color="white"
          text
          rounded
          class="my-2"
          :to="link.route"
        >
          {{ link.name }}
        </v-btn>
        <v-btn
          v-if="isLoggedIn || isClubLoggedIn"
          color="white"
          text
          rounded
          to="/contactus"
          class="my-2"
        >
          Feedback
        </v-btn>
        <v-col
          class="py-4 text-center white--text"
          style="background-color: #32Cd32"
          cols="12"
        >
          {{ new Date().getFullYear() }} — schuetzenbuch.de
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
// import welcome from "./component/welcome";
import sidebar from "./component/sidebar";
import clubsidebar from "./club/component/sidebar.vue";
import BottomNav from "./component/BottomNav.vue";
import CookieLaw from "vue-cookie-law";
import { API } from "@/plugins/axios";
import {
  pwa,
  applyUpdate,
  isIOS,
  isKiosk,
  shouldShowInstallHint,
  dismissInstallHint,
  promptInstall
} from "@/plugins/pwa";

export default {
  name: "index",

  components: {
    // welcome,
    sidebar,
    clubsidebar,
    BottomNav,
    CookieLaw
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters["UserAuth/isLoggedIn"];
    },
    isClubLoggedIn() {
      return this.$store.getters["ClubAuth/isClubLoggedIn"];
    },
    comp_NavigationDrawer: {
      get() {
        return this.$store.getters["GeneralApp/GET_NavbarDrawer"];
      },
      set(val) {
        this.$store.state.GeneralApp.NavigationDrawer = val;
      }
    },
    comp_ShowNavigation() {
      return this.$store.state.GeneralApp.Show_Navigation;
    },
    comp_websocket_state() {
      return this.$store.getters["GeneralApp/is_Websocket_Online"];
    },
    comp_isLoading() {
      return this.$store.getters["GeneralApp/isLoading"];
    },
    comp_backendReachable() {
      return this.$store.getters["GeneralApp/isBackendReachable"];
    },
    comp_updateReady() {
      return pwa.updateReady;
    },
    comp_installPrompt() {
      return pwa.installPrompt;
    },
    // Der Cookie-Hinweis sitzt im Footer und ist mit ihm ausgeblendet
    comp_cookieHintVisible() {
      return this.cookieHintOpen && this.comp_ShowNavigation;
    }
  },

  data: () => ({
    drawer: false,
    showNavigations: true,
    links: [
      { name: "Impressum", route: "/impressum" },
      { name: "Datenschutz", route: "/datenschutz" }
    ],
    _pollingInterval: null,
    cookieHintOpen: false,
    showInstallHint: shouldShowInstallHint(),
    isIOS: isIOS()
  }),

  created() {
    // Listen liegen nicht mehr im localStorage (store/persist.js), deshalb
    // nach einem Neuladen dasselbe holen wie direkt nach dem Login
    if (isKiosk()) return;
    if (this.isLoggedIn) {
      this.$store.dispatch("UserAuth/loadUserData");
    } else if (this.isClubLoggedIn) {
      this.$store.dispatch("ClubAuth/loadClubData");
    }
  },

  mounted() {
    this.cookieHintOpen = this.$refs.cookieLaw.isOpen;
  },

  watch: {
    comp_backendReachable(isReachable) {
      if (!isReachable) {
        // Polling starten - nutze einen bekannt existierenden Endpunkt
        this._pollingInterval = setInterval(() => {
          API.get("/getText", {
            _silent: true,
            params: { text_search: "startseite" }
          }).catch(() => {});
        }, 15000);
      } else {
        // Backend wieder erreichbar → Polling stoppen
        clearInterval(this._pollingInterval);
        this._pollingInterval = null;
      }
    }
  },

  beforeDestroy() {
    clearInterval(this._pollingInterval);
  },

  methods: {
    applyUpdate,
    closeInstallHint() {
      this.showInstallHint = false;
      dismissInstallHint();
    },
    async installApp() {
      if (await promptInstall()) {
        this.closeInstallHint();
      }
    },
    logout() {
      if (this.isLoggedIn) {
        this.$store
          .dispatch("UserAuth/logout")
          .then(() => this.$router.push("/"))
          .catch(err => console.log(err));
      } else if (this.isClubLoggedIn) {
        this.$store
          .dispatch("ClubAuth/logout")
          .then(
            () => this.$router.push("/"),
            this.$store.commit("GeneralApp/SET_SHOW_NAVIGATION", true)
          )
          .catch(err => console.log(err));
      }
    }
  }
};
</script>

<style scoped>
#icon_websocket_online {
  margin-left: 10px;
  color: green;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>